import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-full flex flex-col space-y-5"
}
const _hoisted_2 = { class: "w-full flex flex-row items-center justify-between" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Bookings ")
const _hoisted_4 = { class: "flex flex-row space-x-2" }
const _hoisted_5 = { class: "w-full grid grid-cols-12 gap-3 px-3 border-[1px] border-grey300 rounded-md" }
const _hoisted_6 = { class: "w-full grid grid-cols-2 gap-4" }
const _hoisted_7 = { class: "mdlg:!col-span-1 col-span-full flex flex-col space-y-2 rounded-md border-[1px] border-grey300 px-4 py-4" }
const _hoisted_8 = { class: "w-full flex flex-row items-center justify-between" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Pending Bookings ")
const _hoisted_10 = {
  key: 0,
  class: "w-full flex flex-col space-y-5 pt-2"
}
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Assign")
const _hoisted_12 = {
  key: 1,
  class: "h-full w-full rounded-md bg-grey100 flex flex-row items-center justify-center"
}
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" No booking found ")
const _hoisted_14 = { class: "col-span-full flex flex-col space-y-2 rounded-md border-[1px] border-grey300 px-6 py-4" }
const _hoisted_15 = { class: "w-full flex flex-row items-center justify-between" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Bookings ")
const _hoisted_17 = { class: "w-full flex flex-col py-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_roof_header_text = _resolveComponent("roof-header-text")!
  const _component_roof_select = _resolveComponent("roof-select")!
  const _component_roof_growth_box = _resolveComponent("roof-growth-box")!
  const _component_roof_growth_graph = _resolveComponent("roof-growth-graph")!
  const _component_roof_button = _resolveComponent("roof-button")!
  const _component_roof_action_box = _resolveComponent("roof-action-box")!
  const _component_roof_normal_text = _resolveComponent("roof-normal-text")!
  const _component_roof_table = _resolveComponent("roof-table")!

  return (_ctx.BookingOverview)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_roof_header_text, {
            size: "xl",
            customClass: '!font-extrabold'
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_roof_select, {
              placeholder: "Last 7 days",
              "custom-class": 'w-[120px]',
              paddings: "py-3 px-3"
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_roof_growth_box, {
            label: 'Total Bookings',
            "growth-data": _ctx.BookingOverview?.GetBookingOverview.total_bookings
          }, null, 8, ["growth-data"]),
          _createVNode(_component_roof_growth_box, {
            label: 'Accepted Bookings',
            "growth-data": _ctx.BookingOverview?.GetBookingOverview.accepted_bookings
          }, null, 8, ["growth-data"]),
          _createVNode(_component_roof_growth_box, {
            label: 'Unassigned Bookings',
            "growth-data": _ctx.BookingOverview?.GetBookingOverview.unassigned_bookings
          }, null, 8, ["growth-data"]),
          _createVNode(_component_roof_growth_box, {
            label: 'Canceled Bookings',
            "growth-data": _ctx.BookingOverview?.GetBookingOverview.canceled_bookings
          }, null, 8, ["growth-data"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_roof_growth_graph, {
            data: _ctx.BookingOverview?.GetBookingGrowth,
            label: 'Booking Growth',
            countLabelPlural: 'bookings',
            "count-label-singular": 'booking'
          }, null, 8, ["data"]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_roof_header_text, { size: "lg" }, {
                default: _withCtx(() => [
                  _hoisted_9
                ]),
                _: 1
              })
            ]),
            (_ctx.BookingOverview.UnassignedBookings.data.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.BookingOverview.UnassignedBookings.data, (booking, index) => {
                    return (_openBlock(), _createBlock(_component_roof_action_box, { key: index }, {
                      "avatar-label": _withCtx(() => [
                        _createTextVNode(_toDisplayString(booking.user?.full_name?.charAt(0)), 1)
                      ]),
                      title: _withCtx(() => [
                        _createTextVNode(_toDisplayString(booking.user?.full_name), 1)
                      ]),
                      "sub-title": _withCtx(() => [
                        _createTextVNode(_toDisplayString(booking.service?.name), 1)
                      ]),
                      action: _withCtx(() => [
                        _createVNode(_component_roof_button, {
                          onClick: ($event: any) => (_ctx.showAssignBooking(booking.uuid)),
                          padding: 'py-3 px-4'
                        }, {
                          default: _withCtx(() => [
                            _hoisted_11
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createVNode(_component_roof_normal_text, null, {
                    default: _withCtx(() => [
                      _hoisted_13
                    ]),
                    _: 1
                  })
                ]))
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_roof_header_text, { size: "lg" }, {
              default: _withCtx(() => [
                _hoisted_16
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_roof_table, {
              tableStructure: _ctx.Logic.Booking.BookingTableStructure,
              paginatedData: _ctx.Bookings,
              "table-date-source": _ctx.Logic.Booking.BookingSource,
              "sub-page-route": '/bookings/'
            }, null, 8, ["tableStructure", "paginatedData", "table-date-source"])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}